export const LoginAlertConstant = {
    CHANGE_AUTH_STATUS: 'CHANGE_AUTH_STATUS',
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGIN_ERROR: 'LOGIN_ERROR',
    CLEAR_LOGIN_FAILURE_MESSAGE: 'CLEAR_LOGIN_FAILURE_MESSAGE',
    SET_IS_TOTP_ENABLED: 'SET_IS_TOTP_ENABLED',
    LOGIN_REQUEST: 'LOGIN_REQUEST',
    LOGOUT: 'LOGOUT',
    CSRF_TOKEN_SUCCESS: 'CSRF_TOKEN_SUCCESS',
    PROXY_LOGIN_SUCCESS: 'PROXY_LOGIN_SUCCESS',
    USER_CREDENTIALS: 'USER_CREDENTIALS',
    PASSWORD_CHANGED_BY_OTHER_USER: 'PASSWORD_CHANGED_BY_OTHER_USER',
    UPDATE_FIRSTNAME: "UPDATE_FIRSTNAME",
    UPDATE_SAME_USER_LOGGED_IN_STATUS: "UPDATE_SAME_USER_LOGGED_IN_STATUS",
}